import styled from "styled-components";

export const MainContainer = styled.div`
  padding-bottom: 55px;

  .infos {
    margin-bottom: 28px;

    h3 {
      color: #353535;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 1.5rem;
      line-height: 29px;
    }

    .filters {
      margin-top: 24px;
    }
  }

  .toolBar {
    margin-top: 25px;
    display: flex;
    align-items: center;
    margin-right: 664px;
  }

  @media screen and (max-width: 769px) {
    .infos{
    h3{
      font-size: 17px;
    }
  }
}
`

export const SidebarContainer = styled.div`
  width: 72px;
`
